import { useQuery } from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
import type {
  OrderDevicesResponseType,
  OrderDeviceType,
} from "@/types/orders"

export const getOrderDevices = async (
  orderId: string
): Promise<OrderDeviceType[]> => {
  const url = `${ENDPOINTS.ORDERS}/${orderId}/devices`
  const { data } =
    await api.get<OrderDevicesResponseType>(url)
  // O core devolve um envelope ({ devices: [...] }) porque lista nua vazia vira
  // 204 SEM CORPO no gateway — e o axios entrega corpo ausente como STRING vazia,
  // que não é nullish. `Array.isArray` cobre isso e o formato de lista nua, caso
  // algum ambiente esteja com a versão anterior do core.
  if (Array.isArray(data)) return data
  return Array.isArray(data?.devices) ? data.devices : []
}

/** Devices capturados nas tentativas de pagamento do pedido (aba Dispositivos). */
const useOrderDevices = (
  orderId: string,
  enabled = true
) => {
  return useQuery({
    queryKey: [ENDPOINTS.ORDERS, orderId, "devices"],
    queryFn: () => getOrderDevices(orderId),
    enabled: enabled && Boolean(orderId),
  })
}

export default useOrderDevices
